import React from 'react';
import { ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useNewProjectUrl } from 'domain/shared/newProject';
import ProjectBreadcrumbs from './ProjectFinanceBreadcrumbs';
import { useParams } from 'react-router-dom';

const ChangeRequestBreadcrumbs = ({ children = null }: { children?: React.ReactNode | React.ReactNode[] | null }) => {
  const { getFinanceUrl } = useNewProjectUrl();
  const { id } = useParams();

  return (
    <ProjectBreadcrumbs>
      <ListBreadcrumbItem entity="Change Request" link={getFinanceUrl(id!)} />
      {children}
    </ProjectBreadcrumbs>
  );
};

export default ChangeRequestBreadcrumbs;
